import {
  Assignment as AssignmentIcon,
  AttachMoney as AttachMoneyIcon,
  Build as BuildIcon,
  Business as BusinessIcon,
  Cancel as CancelIcon,
  Description as DescriptionIcon,
  ElectricBolt as ElectricBoltIcon,
  Email as EmailIcon,
  EmojiNature as EmojiNatureIcon,
  Error as ErrorIcon,
  Gavel as GavelIcon,
  Home as HomeIcon,
  Leaderboard as LeaderboardIcon,
  LocalOffer as LocalOfferIcon,
  Newspaper as NewspaperIcon,
  Notifications as NotificationsIcon,
  People as PeopleIcon,
  PhoneCallback as PhoneCallbackIcon,
  Power as PowerIcon,
  PowerOff as PowerOffIcon,
  Security as SecurityIcon,
  ShoppingCart as ShoppingCartIcon,
  Smartphone as SmartphoneIcon,
  TrendingUp as TrendingUpIcon,
  Warning as WarningIcon,
  Web as WebIcon,
  Work as WorkIcon,
} from "@mui/icons-material";
import { WorkTypeEnum } from "../store/types/work.types";

export const getWorkTypeIcon = (type: WorkTypeEnum) => {
  switch (type) {
    case WorkTypeEnum.Opportunity:
      return <TrendingUpIcon fontSize="small" />;
    case WorkTypeEnum.Text:
      return <DescriptionIcon fontSize="small" />;
    case WorkTypeEnum.Prospect:
      return <PeopleIcon fontSize="small" />;
    case WorkTypeEnum.ExternalSaleContract:
      return <AssignmentIcon fontSize="small" />;
    case WorkTypeEnum.UndeliverableDocument:
      return <ErrorIcon fontSize="small" />;
    case WorkTypeEnum.SoftReminder:
      return <NotificationsIcon fontSize="small" />;
    case WorkTypeEnum.PowerOfAttorney:
      return <GavelIcon fontSize="small" />;
    case WorkTypeEnum.Z05:
      return <DescriptionIcon fontSize="small" />;
    case WorkTypeEnum.ChargeBoxWork:
      return <ElectricBoltIcon fontSize="small" />;
    case WorkTypeEnum.Z04:
      return <DescriptionIcon fontSize="small" />;
    case WorkTypeEnum.Leads:
      return <LeaderboardIcon fontSize="small" />;
    case WorkTypeEnum.ManualContractCancellation:
      return <CancelIcon fontSize="small" />;
    case WorkTypeEnum.FöretagIKonkurs:
      return <WarningIcon fontSize="small" />;
    case WorkTypeEnum.FöretagILikvidation:
      return <WarningIcon fontSize="small" />;
    case WorkTypeEnum.MarkavtalSwishOut:
      return <AttachMoneyIcon fontSize="small" />;
    case WorkTypeEnum.CustomerWorkFromWeb:
      return <WebIcon fontSize="small" />;
    case WorkTypeEnum.ChangeInEnskildFirma:
      return <BusinessIcon fontSize="small" />;
    case WorkTypeEnum.DalaVind2023:
    case WorkTypeEnum.DalaVind2024:
      return <EmojiNatureIcon fontSize="small" />;
    case WorkTypeEnum.DalaHemlarmInterest:
      return <SecurityIcon fontSize="small" />;
    case WorkTypeEnum.IncomingEmail:
      return <EmailIcon fontSize="small" />;
    case WorkTypeEnum.AppMessage:
      return <SmartphoneIcon fontSize="small" />;
    case WorkTypeEnum.PowerOutage:
      return <PowerOffIcon fontSize="small" />;
    case WorkTypeEnum.EnergyPoolOrder:
      return <ShoppingCartIcon fontSize="small" />;
    case WorkTypeEnum.SharedEnergySystem:
      return <PowerIcon fontSize="small" />;
    case WorkTypeEnum.AvestaElpool2024:
      return <ElectricBoltIcon fontSize="small" />;
    case WorkTypeEnum.Estate:
      return <HomeIcon fontSize="small" />;
    case WorkTypeEnum.DalaVindNyhetsbrev:
      return <NewspaperIcon fontSize="small" />;
    case WorkTypeEnum.FöretagIRekonstruktion:
      return <BuildIcon fontSize="small" />;
    case WorkTypeEnum.BrfGruven2025:
      return <HomeIcon fontSize="small" />;
    case WorkTypeEnum.WelcomeCallExternalSale:
      return <PhoneCallbackIcon fontSize="small" />;
    case WorkTypeEnum.EnergyMemberPayout:
      return <AttachMoneyIcon fontSize="small" />;
    case WorkTypeEnum.SecureVolume:
      return <SecurityIcon fontSize="small" />;
    case WorkTypeEnum.Other:
      return <LocalOfferIcon fontSize="small" />;
    default:
      return <WorkIcon fontSize="small" />;
  }
};

export const getWorkTypeName = (type: WorkTypeEnum): string => {
  switch (type) {
    case WorkTypeEnum.NotSet:
      return "Ej satt";
    case WorkTypeEnum.Other:
      return "Övrigt";
    case WorkTypeEnum.Opportunity:
      return "Affärsmöjlighet";
    case WorkTypeEnum.Text:
      return "Text";
    case WorkTypeEnum.Prospect:
      return "Prospekt";
    case WorkTypeEnum.ExternalSaleContract:
      return "Externt säljkontrakt";
    case WorkTypeEnum.UndeliverableDocument:
      return "Oleverbart dokument";
    case WorkTypeEnum.SoftReminder:
      return "Mjuk påminnelse";
    case WorkTypeEnum.PowerOfAttorney:
      return "Fullmakt";
    case WorkTypeEnum.Z05:
      return "Z05";
    case WorkTypeEnum.ChargeBoxWork:
      return "Laddbox";
    case WorkTypeEnum.Z04:
      return "Z04";
    case WorkTypeEnum.Leads:
      return "Leads";
    case WorkTypeEnum.ManualContractCancellation:
      return "Manuell uppsägning";
    case WorkTypeEnum.FöretagIKonkurs:
      return "Företag i konkurs";
    case WorkTypeEnum.FöretagILikvidation:
      return "Företag i likvidation";
    case WorkTypeEnum.MarkavtalSwishOut:
      return "Markavtal Swish ut";
    case WorkTypeEnum.CustomerWorkFromWeb:
      return "Kundärende från webb";
    case WorkTypeEnum.ChangeInEnskildFirma:
      return "Ändring enskild firma";
    case WorkTypeEnum.DalaVind2023:
      return "DalaVind 2023";
    case WorkTypeEnum.DalaHemlarmInterest:
      return "DalaHemlarm intresse";
    case WorkTypeEnum.IncomingEmail:
      return "Inkommande e-post";
    case WorkTypeEnum.AppMessage:
      return "Appmeddelande";
    case WorkTypeEnum.PowerOutage:
      return "Strömavbrott";
    case WorkTypeEnum.EnergyPoolOrder:
      return "Energipool order";
    case WorkTypeEnum.DalaVind2024:
      return "DalaVind 2024";
    case WorkTypeEnum.SharedEnergySystem:
      return "Delad energi";
    case WorkTypeEnum.AvestaElpool2024:
      return "Avesta Elpool 2024";
    case WorkTypeEnum.Estate:
      return "Dödsbo";
    case WorkTypeEnum.DalaVindNyhetsbrev:
      return "DalaVind nyhetsbrev";
    case WorkTypeEnum.FöretagIRekonstruktion:
      return "Företag i rekonstruktion";
    case WorkTypeEnum.BrfGruven2025:
      return "BRF Gruven 2025";
    case WorkTypeEnum.WelcomeCallExternalSale:
      return "Välkomstsamtal extern";
    case WorkTypeEnum.EnergyMemberPayout:
      return "Energimedlem utbetalning";
    case WorkTypeEnum.SecureVolume:
      return "Säkra volym";
    default:
      return "Okänd typ";
  }
};

export const getWorkTypeColor = (type: WorkTypeEnum): string => {
  switch (type) {
    case WorkTypeEnum.Opportunity:
      return "#9c27b0"; // Purple
    case WorkTypeEnum.Leads:
      return "#4caf50"; // Green
    case WorkTypeEnum.IncomingEmail:
      return "#2196f3"; // Blue
    case WorkTypeEnum.AppMessage:
      return "#00bcd4"; // Cyan
    case WorkTypeEnum.Prospect:
      return "#ff9800"; // Orange
    case WorkTypeEnum.ExternalSaleContract:
    case WorkTypeEnum.ManualContractCancellation:
      return "#607d8b"; // Blue Gray
    case WorkTypeEnum.PowerOfAttorney:
      return "#795548"; // Brown
    case WorkTypeEnum.FöretagIKonkurs:
    case WorkTypeEnum.FöretagILikvidation:
    case WorkTypeEnum.FöretagIRekonstruktion:
      return "#f44336"; // Red
    case WorkTypeEnum.ChargeBoxWork:
    case WorkTypeEnum.PowerOutage:
    case WorkTypeEnum.EnergyPoolOrder:
    case WorkTypeEnum.SharedEnergySystem:
    case WorkTypeEnum.AvestaElpool2024:
      return "#ff5722"; // Deep Orange
    case WorkTypeEnum.DalaVind2023:
    case WorkTypeEnum.DalaVind2024:
    case WorkTypeEnum.DalaVindNyhetsbrev:
      return "#4caf50"; // Green
    case WorkTypeEnum.DalaHemlarmInterest:
      return "#3f51b5"; // Indigo
    case WorkTypeEnum.Estate:
      return "#e91e63"; // Pink
    case WorkTypeEnum.CustomerWorkFromWeb:
      return "#009688"; // Teal
    case WorkTypeEnum.WelcomeCallExternalSale:
      return "#ff9800"; // Orange
    case WorkTypeEnum.SecureVolume:
      return "#3f51b5"; // Indigo
    case WorkTypeEnum.EnergyMemberPayout:
    case WorkTypeEnum.MarkavtalSwishOut:
      return "#8bc34a"; // Light Green
    default:
      return "#757575"; // Gray
  }
};
